import { useNavigate, useLocation } from "react-router-dom";
import TrialDetail from "shared/Trail/TrialDetail";

export const ManageTrailDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customData } = location.state || {};
  const onGoBack = () => {
    navigate("/admin/manage/trial");
  };

  return (
    <div className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}>
      <TrialDetail detail={customData} goBack={onGoBack} smPadding={true} />
    </div>
  );
};
